var map = {
	"./afiliat/tazz.png": "e8bc",
	"./beneficiary/banner_recommend_2.png": "a82b",
	"./beneficiary/uponline-multibeneficii.png": "ceb5",
	"./client/banner_campanie_vn.png": "40dc",
	"./client/banner_emi.jpg": "1c98",
	"./client/banner_kadra.jpg": "afa5",
	"./client/banner_recommend_3.jpg": "0174",
	"./client/vn-dejun3.png": "e437",
	"./login/companii/vn-dejun2.png": "dd78",
	"./login/utilizatori/banner_mobilplus.png": "c3ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0208";